import { useState, useEffect } from 'react'

export default function useLocalStorageState(initialState, key) {
  const [state, setState] = useState(() => {
    if (
      typeof window !== 'undefined' &&
      window.localStorage
    ) {
      if (window.localStorage.getItem(key)) {
        const storedState = JSON.parse(window.localStorage.getItem(key))

        if (typeof storedState === 'string') {
          return storedState
        }

        if (Array.isArray(storedState)) {
          return [
            ...initialState,
            ...storedState,
          ]
        }

        return {
          ...initialState,
          ...storedState,
        }
      } else if (initialState) {
        window.localStorage.setItem(key, JSON.stringify(initialState))
      }
    }

    return initialState
  })

  const onStateChange = (nextState) => {
    if (typeof nextState === 'function') {
      nextState = nextState(state)
    }

    setState(nextState)

    if (typeof window !== 'undefined' && window.localStorage) {
      if (!nextState) {
        window.localStorage.removeItem(key)
      } else {
        window.localStorage.setItem(key, JSON.stringify(nextState))
      }
    }
  }

  return [state, onStateChange]
}
